import Footer from "../Footer";
import Header from "../Header";
import textPage1 from "../assets/img/text-page__img-1.png";
import textPage2 from "../assets/img/text-page__img-2.png";

const AboutUs = () => {
  return (
    <div className="body">
      <Header />

      <div className="wrapper">
        <main className="page">
          <section className="content">
            <div className="container-fix-width">
              <div className="content__blocks-wrap">
                <div className="content__block-item">
                  <div className="content__image-block">
                    <div className="content__image-wrap">
                      <img src={textPage1} alt="image" />
                    </div>
                  </div>
                  <div className="content__text-block">
                    <h1>About Us</h1>
                    <p>
                      Welcome to <strong>SportBeagle</strong> — your smart,
                      unbiased guide in the world of football betting. Built by
                      bettors, for bettors, our mission is to help you make
                      smarter, faster, and more profitable betting decisions
                      using powerful tools and real-time data. We don’t just
                      show odds — we give you the edge.
                    </p>
                    <p>
                      We know how overwhelming it can be to find real value
                      among thousands of games and dozens of bookmakers. That’s
                      why we created a platform that puts{" "}
                      <strong>bettors first</strong> — with{" "}
                      <strong>no ads</strong>, no distractions, and no hidden
                      agendas. Whether you’re looking for the best odds, trying
                      to compare markets, or diving into stats, SportBeagle
                      simplifies the process and helps you stay ahead.
                    </p>
                  </div>
                </div>
                <div className="content__block-item reverse">
                  <div className="content__image-block">
                    <div className="content__image-wrap">
                      <img src={textPage2} alt="image" />
                    </div>
                  </div>
                  <div className="content__text-block">
                    <h2>What makes us different?</h2>
                    <p>
                      <strong>Our exclusive AI-powered tool</strong> helps you
                      discover{" "}
                      <strong>
                        rare, high-probability, low-risk betting opportunities
                      </strong>{" "}
                      you won’t find elsewhere. Combine that with in-depth
                      analytics, market filters, expert insights, and full
                      bookmaker transparency — and you've got everything you
                      need to make smart bets, all in one place.
                    </p>
                  </div>
                </div>
              </div>
              <p>
                At SportBeagle, we believe in transparency, integrity, and
                empowering a new generation of informed bettors. Join us — and
                turn your betting into a winning experience.
              </p>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
